<template>
  <div v-if="selectedBeneficiaryId === null" class="beneficary-page">
    <div>
      <div class="left">
        <h1>{{ $t("beneficiariesTitle") }}</h1>
        <p>{{ $t("beneficiariesDescription") }}</p>
      </div>
      <div class="right">
        <a href="/customer/new_order" class="notification-action custom-notification-action">{{ $t("newOrderName") }}</a>
      </div>
    </div>
    <br clear="all" />
    <!-- filter-mobile -->
    <div class="container-alb filter-mobile">
      <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
        <tr>
          <td>
            <img src="@/assets/images/filter.svg" />
            <span class="mobile-show">
              &nbsp;&nbsp;
              {{ $t("beneficiariesFilterTitle") }}
            </span>
          </td>
          <td>
            {{ $t("beneficiariesFilterCardType") }}
            <select class="filtrare" @change="productSelected">
              <option v-for="(entry, index) in cardProducts" :key="index" :value="entry.brand"
                :selected="isSelectedProduct(entry.brand)">
                {{ entry.name }}
              </option>
            </select>
          </td>
          <td>
            {{ $t("beneficiariesFilterCardStatus") }}
            <select class="filtrare" @change="cardStatusSelected">
              <option v-for="(entry, index) in cardStatuses" :key="index" :value="entry.value"
                :selected="isSelectedCardStatus(entry.card)">
                {{ $t("cardStatus_" + entry.descriptionCode) }}
                <!-- {{entry.descriptionCode}} -->
              </option>
            </select>
          </td>
          <td>
            {{ $t("beneficiariesFilterProductType") }}
            <select class="filtrare" @change="productTypeSelected">
              <option v-for="(entry, index) in productTypes" :key="index" :value="entry.type"
                :selected="isSelectedProductType(entry.type)">
                {{ $t("productType_" + entry.type) }}
                <!-- {{entry.descriptionCode}} -->
              </option>
            </select>
          </td>
          <td>
            {{ $t("beneficiariesFilterDeliveryAddress") }}
            <select class="filtrare" @change="addressFilterSelected">
              <option v-for="(entry, index) in deliveryAddresses" :key="index" :value="entry.codcom"
                :selected="isSelectedFilterAddress(entry.codcom)">
                {{
    entry.codcom === 0
      ? $t("cardStatus_")
      : entry.codcom +
      " - " +
      entry.address.street_name +
      ", " +
      entry.address.locality
  }}
              </option>
            </select>
          </td>
          <!-- <td>
            {{ $t("beneficiariesFilterHddid") }}
            <input type="text" class="formedituser" v-model="filters.hddid"
              v-on:keyup.enter="loadCustomerBeneficiaries()" />
          </td> -->
        </tr>
        <tr >
          <td colspan="3">
            {{ $t("beneficiariesFileUploadText") }}
          </td>
          <td colspan="2">
            <b-form-file v-model="fileReceived" ref="file" accept=".xls, .xlsx" :placeholder="$t('uploadFileLabel')"
              @input="uploadFile"></b-form-file>
          </td>
          <!-- <td>
            <div class="w-100 text-right">
              <a
                @click="fileReceived = null"
                class="status-background background-will-expire"
                >Reset</a
            </div>
          </td> -->
        </tr>
      </table>
    </div>

    <div class="container-alb moverflow">
      <table cellpadding="10" cellspacing="0" width="95%" align="center">
        <tr>
          <td>
            <h3 class="table-title">
              {{ $t("beneficiariesTitle") }}
              <img class="download" @click="getExcelBeneficiaries2" src="@/assets/images/download.svg" />
            </h3>
          </td>
          <td align="right">
            <input type="text" v-bind:placeholder="$t('beneficiariesFilterKeyword')" class="formedituser search-input"
              v-model="filters.hddid" v-on:keyup.enter="loadCustomerBeneficiaries()" />
            <a class="search-btn cursor-pointer" @click="loadCustomerBeneficiaries()">
              <img src="@/assets/images/search.svg" alt />
            </a>
          </td>
        </tr>
        <tr>
          <td class="loading-message">
            <a class="action-button selectAll" :class="this.isSelectedAllCustomerBeneficiaries && 'isActive'"
              @click="loadAndCheckAllBeneficiaries()">
              <span v-if="!this.isSelectedAllCustomerBeneficiaries">
                {{
    $t("beneficiariesSelectAll") +
    "&nbsp;(" +
    this.selectedBeneficiaries.length +
    ")"
  }}
              </span>
              <span v-else>
                {{
      $t("beneficiariesDeselectAll") +
      "&nbsp;(" +
      this.selectedBeneficiaries.length +
      ")"
    }}
              </span>
            </a>
            <span v-if="this.selectedBeneficiaries.length == 0 && this.isSelectedAllCustomerBeneficiaries"
              class="loading-message">
              <img src="@/assets/images/loading-square.gif" />
              <span v-html="$t('loadingMessage')" />
            </span>
          </td>
          <td></td>
        </tr>
      </table>

      <div class="loading" v-if="this.customerBeneficiaries === null">
        <img src="@/assets/images/loading.gif" />
      </div>
      <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center"
        v-if="this.customerBeneficiaries !== null">
        <tr>
          <td valign="middle">
            <input type="checkbox" @change="checkAllBeneficiaries($event.target)" />
          </td>
          <td valign="middle">
            <strong>{{ $t("noCrtLabel") }}</strong>
          </td>
          <td valign="middle" @click="() => (sortByField = 'HD1NAME')">
            <strong>{{
    isFilterProductReward
      ? $t("beneficiariesTableTextOnCard")
      : $t("beneficiariesTableSurname")
  }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy('HD1NAME')" :style="sortByField === 'HD1NAME' &&
    reverse &&
    'transform: rotate(180deg)'
    " />
          </td>
          <td class="priority-0" valign="middle" @click="() => (sortByField = 'HDNAME')">
            <strong>{{
    isFilterProductReward
      ? $t("beneficiariesTableDetails")
      : $t("beneficiariesTableName")
  }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy('HDNAME')" :style="sortByField === 'HDNAME' &&
    reverse &&
    'transform: rotate(180deg)'
    " />
          </td>
          <td class="priority-1" valign="middle" @click="() => (sortByField = 'HDIDCARD')">
            <strong>{{
    $t("beneficiariesTableCNP")
  }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy('HDIDCARD')" :style="sortByField === 'HDIDCARD' &&
    reverse &&
    'transform: rotate(180deg)'
    " />
          </td>
          <td v-if="isFilterProductReward" class="priority-1" valign="middle">
            <strong>{{
    $t("beneficiariesTableAmount")
  }}</strong>&nbsp;
          </td>
          <td class="priority-3" valign="middle">
            <strong>{{ $t("beneficiariesTableType") }}</strong>&nbsp;
          </td>
          <td class="priority-3" valign="middle">
            <strong>{{ $t("beneficiariesTableExpire") }}</strong>&nbsp;
          </td>
          <td class="priority-3" valign="middle">
            <strong>{{ $t("beneficiariesTableCardStatus") }}</strong>&nbsp;
          </td>
          <td class="priority-5" valign="middle">
            <strong>{{ $t("beneficiariesTableStatus") }}</strong>&nbsp;
          </td>
          <td valign="middle">&nbsp;</td>
        </tr>

        <template v-for="(entry, index) in this.customerBeneficiaries">
          <tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
            <td valign="middle">
              <input type="checkbox" @change="beneficiaryChecked($event.target, entry)" v-if="entry.active"
                :checked="isBeneficiaryChecked(entry) >= 0" />
            </td>
            <td valign="middle">
              <a @click="selectBeneficiaryMobile(index)" class="detailsOrderMobile priority-show-5 display-inline-block">
                <font-awesome-icon icon="minus-circle" v-if="detailsMobile && entry === selectedBeneficiary" />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <span class="crt">&nbsp;&nbsp;{{ index + 1 }}</span>
            </td>
            <td valign="middle">
              <span>{{ entry.first_name }}</span>
            </td>
            <td class="priority-0" valign="middle">{{ entry.last_name }}</td>
            <td class="priority-1" valign="middle">
              {{ entry.cnp }}
            </td>
            <td v-if="isFilterProductReward" class="priority-1" valign="middle">
              <span>
                {{ entry.accounts[0].label | toCurrency }}
              </span>
            </td>
            <td>
              {{
    $t(
      "beneficiariesTableDigital_" + entry.accounts[0].card.virtual
    )
  }}
            </td>
            <td class="priority-2" valign="middle">
              {{ entry.accounts[0].card.expire }}
            </td>
            <td class="priority-3" valign="middle">
              <span class="status-background" :class="getClassForCardStatus(entry.accounts[0].card.state)">{{
    $t("cardStatus_" + entry.accounts[0].card.state) }}</span>
            </td>
            <!-- <td class="priority-4" valign="middle">
              <a class="info">
                <img
                  v-if="cardHasAction(entry.accounts[0].card.state)"
                  :src="require('@/assets/images/action-' + $t('cardStatus_' + entry.accounts[0].card.state) + '.svg')"
                />
                <div class="pop-hover">Actions</div>
              </a>
            </td>-->
            <td class="priority-5" valign="middle">
              <span class="status-background" :class="entry.active ? 'background-active' : 'background-suspended'
    ">{{
    entry.active
      ? $t("beneficiaryStatus_Active")
      : $t("beneficiaryStatus_Inactive")
  }}</span>
            </td>
            <td valign="middle">
              <a class="see-more" @click="selectedBeneficiaryId = entry.id">
                <font-awesome-icon icon="arrow-alt-circle-right" size="2x" />
              </a>
            </td>
          </tr>
          <tr :key="customerBeneficiaries.length + index" class="child" :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && entry === selectedBeneficiary">
            <td colspan="12">
              <p class="priority-show-0">
                <strong>{{ $t("beneficiariesTableName") }} : &nbsp;&nbsp;</strong>
                <span>{{ entry.last_name }}</span>
              </p>
              <p class="priority-show-1">
                <strong>{{ $t("beneficiariesTableCNP") }} : &nbsp;&nbsp;</strong>
                <span>{{ entry.cnp }}</span>
              </p>
              <p>
                {{
    $t(
      "beneficiariesTableDigital_" +
      entry.accounts[0].card.virtual
    )
  }}
              </p>
              <p class="priority-show-3">
                <strong>{{ $t("beneficiariesTableExpire") }} : &nbsp;&nbsp;</strong>
                <span>{{ entry.accounts[0].card.expire }}</span>
              </p>
              <p class="priority-show-3">
                <strong>{{ $t("beneficiariesTableCardStatus") }} :
                  &nbsp;&nbsp;</strong>
                <span class="status-background" :class="getClassForCardStatus(entry.accounts[0].card.state)">{{
    $t("cardStatus_" + entry.accounts[0].card.state) }}</span>
              </p>
              <!-- <p class="priority-show-4">
                <strong>{{ $t("beneficiariesTableAction") }} : &nbsp;&nbsp;</strong>
                <span>
                  <a class="info">
                    <img
                      v-if="cardHasAction(entry.accounts[0].card.state)"
                      :src="require('@/assets/images/action-' + $t('cardStatus_' + entry.accounts[0].card.state) + '.svg')"
                    />
                    <div class="pop-hover">Actions</div>
                  </a>
                </span>
              </p>-->
              <p class="priority-show-5">
                <strong>{{ $t("beneficiariesTableStatus") }} : &nbsp;&nbsp;</strong>
                <span class="status-background" :class="entry.active ? 'background-active' : 'background-suspended'
    ">{{
    entry.active
      ? $t("beneficiaryStatus_Active")
      : $t("beneficiaryStatus_Inactive")
  }}</span>
              </p>
            </td>
          </tr>
        </template>
<tr v-if="this.customerBeneficiaries.length === 0">
  <td colspan="10">{{ $t("noBeneficiariesInfoMessage") }}</td>
</tr>
</table>

<div class="pagination-wrapper border-box">
  <b-pagination v-model="currentPage" :total-rows="this.beneficiariesCount" :per-page="perPage"
    size="sm"></b-pagination>
</div>
</div>
<div v-if="this.selectedBeneficiaries.length > 0" class="container-alb">
  <div class="wrapper-beneficiaries-actions">
    <p>
      {{ $t("actionsText", { count: this.selectedBeneficiaries.length }) }}
    </p>
    <br />
    <div>
      <div id="actionSelect">
        <b-row class="border-box">
          <b-col cols="3" sm="2" md="2" class="border-box">
            <span>{{ $t("beneficiariesActionSelect") }}:</span>
          </b-col>
          <b-col cols="9" sm="6" md="6" class="border-box">
            <select @change="actionSelected" class="filtrare">
              <option v-for="(entry, index) in cardActions" :key="index" :value="entry"
                :selected="selectedAction === entry">
                {{ $t("cardsAction_" + entry) }}
              </option>
            </select>
          </b-col>
        </b-row>
      </div>
      <br />
      <div id="addressActionSelect">
        <b-row class="border-box">
          <b-col cols="3" sm="2" md="2" class="border-box">
            <span>{{ $t("beneficiariesFilterDeliveryAddress") }}:</span>
          </b-col>
          <b-col cols="9" sm="6" md="6" class="border-box">
            <select @change="addressActionSelected" class="filtrare">
              <option v-for="(entry, index) in deliveryAddresses" :key="index" :value="entry.codcom"
                :selected="selectedAction === entry.codcom">
                {{
                  entry.codcom === 0 ? $t("cardStatus_") : entry.codcom + " - " + entry.address.street_name + ", " +
                    entry.address.locality
                }}
              </option>
            </select>
          </b-col>
        </b-row>
      </div>
      <div v-if="selectedAction === 'CLO'">
        {{ $t('actionCLOMessage', {code: 1}) }}
      </div>
      <br />
      <!-- <div v-if="selectedAction === 'DELETE'">
        <p v-html="$t('confirmActionBeneficiary_DELETE')" />        
      </div> -->
      <br />
      <a class="status-background background-active" href="#" @click="validateSelection()">{{ $t("confirmButtonLabel")
        }}</a>
    </div>
  </div>
</div>

<!-- popup confirmare actiune  -->
<div class="overlayer" v-if="this.openDetails">
  <div class="container-alb moverflow">
    <a class="close-button" @click="viewDetails(false)">
      <img src="@/assets/images/close-button.svg" />
    </a>
    <div class="scroll-popup">
      <div class="header-order-details">
        <div class="order-details-title">
          <h1>{{ $t("cardsAction_" + this.selectedAction) }}</h1>
          <p>{{ $t("actionConfirmMessage") }}</p>
          <p v-if="this.selectedAction === 'DEACT'">
            {{ $t("cardsActionDeactCardMessage") }}
          </p>
        </div>
        <div class="right">
          <a class="notification-action" href="#" @click="submitAction()">{{
            $t("confirmButtonLabel")
          }}</a>
        </div>
      </div>
      <br clear="all" />
      <div class="header-order-details" v-if="this.selectedAction === 'REPL'">
        <div class="order-details-title" >
            <h5>{{ $t("orderPurchaseOrderTitle") }}</h5>
          <input type="text" v-model="purchaseOrder" class="input-add-beneficiary" />
        </div>
        <div  class="right">
          <h5>{{ $t("orderGeneralCommentTitle") }}</h5>
          <input type="text" v-model="generalComment" class="input-add-beneficiary" max="50" />
        </div>
      </div>
      <br clear="all" />
      <div class="header-table">
        <div class="left">
          <h3>{{ $t("beneficiariesName") }}</h3>
        </div>
      </div>
      <table id="selectedBeneficiariesListDisplay" cellpadding="10" cellspacing="0" width="95%" class="hover-table"
        align="center">
        <tr>
          <td valign="middle">
            <strong>{{ $t("beneficiariesTableSurname") }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" />
          </td>
          <td valign="middle">
            <strong>{{ $t("beneficiariesTableName") }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" />
          </td>
          <td valign="middle">
            <strong>{{ $t("beneficiariesTableCNP") }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" />
          </td>
          <!-- <td valign="middle">
                <strong>{{ $t("beneficiariesTableTableType") }}</strong
                >&nbsp;
                <img src="@/assets/images/arrow-down-fill.svg" />
              </td> -->
          <td valign="middle">
            <strong>{{ $t("beneficiariesTableCardStatus") }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" />
          </td>
        </tr>

        <tr v-for="(beneficiary, index) in this.selectedBeneficiaries" :key="index" class="trhover"
          :class="index % 2 === 0 && 'gri-cell'">
          <td>{{ beneficiary.first_name }}</td>
          <td>{{ beneficiary.last_name }}</td>
          <td>{{ beneficiary.cnp }}</td>
          <!-- <td>
                {{
                  $t(
                    "beneficiariesTableDigital_" +
                      beneficiary.accounts[0].card.virtual
                  )
                }}
              </td> -->
          <td valign="middle">
            <span class="status-background" :class="getClassForCardStatus(beneficiary.accounts[0].card.state)
    ">{{
    $t("cardStatus_" + beneficiary.accounts[0].card.state)
  }}</span>
          </td>
          <td>
            <a class="cursor-pointer" @click="removeBeneficiary(beneficiary)">
              <font-awesome-icon icon="user-minus" size="2x" />
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div id="modal_popup_info" class="modal-popup">
  <div class="modal-popup-content">
    <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
      <img src="@/assets/images/close-button.svg" />
    </a>
    <p v-if="this.error" v-html="$t('errorActionBeneficiary_' + this.error.code)"></p>
    <div v-if="this.actionOrderErrors">
      <p v-for="(error, index) in this.actionOrderErrors" :key="index" class="trhover"
        :class="index % 2 === 0 && 'gri-cell'">
        {{ $t(error.error_code, { name: error.description }) }}
      </p>
    </div>
    <p v-if="this.actionSuccess" v-html="$t('actionSuccessMessage', {
    action: $t('cardsAction_' + this.selectedAction),
  })
    "></p>
  </div>
</div>
<div id="modal_popup_delete_ben_info" class="modal-popup">
  <div class="modal-popup-content">
    <a @click="showModalPopup('modal_popup_delete_ben_info', false)" class="close-button">
      <img src="@/assets/images/close-button.svg" />
    </a>
    <p  v-html="$t('confirmActionBeneficiary_DELETE_BENEFICIARY')"></p>
    <br />
    <a class="notification-action" @click="showModalPopup('modal_popup_delete_ben_info', false)">{{ $t("nextStepButtonLabel")
        }}</a>
  </div>
</div>
</div>

<div v-else>
  <h3 class="return">
    <a href="#" @click="selectedBeneficiaryId = null">
      <font-awesome-icon icon="chevron-left" />
      <span>{{ $t("backButtonLabel") }}</span>
    </a>
  </h3>
  <BeneficiaryDetails :beneficiaryId="selectedBeneficiaryId" :deliveryAddresses="this.deliveryAddresses"
    :customer="this.customer" :userRole="this.userRole" />
</div>
</template>

<script>
  import httpServiceCustomer from "@/http/http-customer.js";
  import httpServiceCompany from "@/http/http-user.js";
  import BeneficiaryDetails from "@/components/company/customer/BeneficiaryDetails.vue";
  import utils from "@/plugins/utils.js";
  import { BPagination, BRow, BCol, BFormFile } from "bootstrap-vue";
  import Cookies from "js-cookie";
  import { saveAs } from "file-saver";
  import products from "@/assets/json/products.js";

  export default {
    components: {
      BeneficiaryDetails,
      "b-pagination": BPagination,
      "b-row": BRow,
      "b-col": BCol,
      "b-form-file": BFormFile
    },
    props: {
      customer: Object,
      // accessToken: String,
      msg: String,
      user: Object,
      userRole: String,
    },

    data() {
      return {
        accessToken: null,
        customerBeneficiaries: null,
        selectedBeneficiary: null,
        detailsMobile: null,
        excelBeneficiaries: null,
        selectedBeneficiaries: [],
        deliveryAddresses: null,
        error: null,
        actionOrderErrors: null,
        fileReceived: null,
        purchaseOrder: "",
        generalComment: "",
        filters: {
          product: 11,
          beneficiaryStatus: null,
          cardStatus: "",
          productType: "",
          deliveryAddress: null,
          keyword: "",
          hddid: "",
          content: null
        },
        excelFields: {
          "First name": "first_name",
          "Last name": "last_name",
          "Cardholder ID": "cnp",
          "Expires at": {
            field: "accounts",
            callback: (value) => {
              return value[0].card.expire;
            },
          },
          "Card status": {
            field: "accounts",
            callback: (value) => {
              return this.$t("cardStatus_" + value[0].card.state, "en");
            },
          },
        },
        selectedBeneficiaryId: null,
        selectedAction: "CHOOSE",
        selectedDeliveryAddress: null,
        cardActions: [
          "CHOOSE",
          "ACT",
          "DEACT",
          // "ACT_ALL",
          "REPL",
          "BLOK",
          "DEBLOK",
          "CLO",
          "DELETE_BENEFICIARY",
          // "PIN",
          // "VALIDATE_REPL",
          // "VALIDATE_PIN",
          // "REN"
        ],
        openDetails: false,
        cardStatuses: [
          {
            value: "",
            descriptionCode: "",
          },
          {
            value: "A",
            descriptionCode: "A",
          },
          {
            value: "B,F",
            descriptionCode: "B",
          },
          {
            value: "D",
            descriptionCode: "D",
          },
          {
            value: "C",
            descriptionCode: "C",
          },
          {
            value: "X",
            descriptionCode: "X",
          },
          // L cancelled
          {
            value: "E,I,M,N,O,P,R,S",
            descriptionCode: "E",
          },
          {
            value: "RN",
            descriptionCode: "RN",
          },
          // {
          //   value: "RC",
          //   descriptionCode: "RC"
          // },
          // {
          //   value: "RP",
          //   descriptionCode: "RP"
          // }
        ],
        productTypes: [
          {
            type: "",
            descriptionCode: "",
          },
          {
            type: "D",
            descriptionCode: "",
          },
          {
            type: "P",
            descriptionCode: "",
          }
        ],
        actionSuccess: false,
        perPage: 10,
        currentPage: 1,
        beneficiariesCount: 10,
        sortByField: "HDNAME",
        reverse: false,
        isSelectedAllCustomerBeneficiaries: false,
      };
    },
    methods: {
      selectBeneficiaryMobile(index) {
        this.selectedBeneficiary = this.customerBeneficiaries[index];
        this.detailsMobile = !this.detailsMobile;
      },
      sortBy(fieldName) {
        if (this.sortByField !== fieldName) {
          this.reverse = false;
        }
        this.sortByField = fieldName;
        this.reverse = !this.reverse;
        this.loadCustomerBeneficiaries();
      },
      uploadFile() {
        var reader = new FileReader();
        reader.onload = e => {
          if (!e) {
            this.filters.content = btoa(reader.content);
          } else {
            this.filters.content = btoa(e.target.result);
            this.loadCustomerBeneficiaries();
          }
        };
        //For Browsers other than IE.
        if (reader.readAsBinaryString) {
          reader.readAsBinaryString(this.fileReceived);
        } else {
          alert("This browser does not support HTML5.");
        }

        if (!this.fileReceived) {
          return;
        }
        // */
      },
      loadCustomerBeneficiaries() {
        if (this.perPage < 5000) {
          this.customerBeneficiaries = null;
        }
        // retreive customer beneficiaries from service
        // var formData = "?product=" + this.filters.product.card;
        // formData += "&brand=" + this.filters.product.brand;
        // if (this.filters.beneficiaryStatus) {
        //   formData += "&beneficiary_status=" + this.filters.beneficiaryStatus;
        // }
        // if (this.filters.cardStatus !== "") {
        //   formData += "&card_status=" + this.filters.cardStatus;
        // }
        // if (this.filters.deliveryAddress && this.filters.deliveryAddress > 0) {
        //   formData += "&coddp=" + this.filters.deliveryAddress;
        // }
        // if (this.filters.keyword) {
        //   formData += "&keyword=" + this.filters.keyword;
        // }
        // formData += "&per_page=" + this.perPage + "&page=" + this.currentPage;
        // if (this.reverse) {
        //   formData += "&sort=desc";
        //   formData += "&desc=" + this.sortByField;
        // } else {
        //   formData += "&sort=asc";
        //   formData += "&asc=" + this.sortByField;
        // }

        var formData = {
          products: [this.filters.product.card],
          brand: this.filters.product.brand,
          per_page: this.perPage,
          page: this.currentPage
        };
        if (this.filters.beneficiaryStatus) {
          formData.holder_status = this.filters.beneficiaryStatus;
        }
        if (this.filters.cardStatus !== "") {
          formData.card_statuses = this.filters.cardStatus.split(",");
        }
        if (this.filters.hddid) {
          formData.hddid = this.filters.hddid;
        }

        if (this.filters.deliveryAddress && this.filters.deliveryAddress > 0) {
          formData.address_code = this.filters.deliveryAddress;
        }
        if (this.filters.keyword) {
          formData.keyword = this.filters.keyword.trim();
        }
        if (this.filters.productType) {
          formData.digital = this.filters.productType;
        }
        if (this.filters.content) {
          formData.content = this.filters.content.trim();
        }
        if (this.reverse) {
          formData.sort = "desc";
          formData.desc = [this.sortByField];
        } else {
          formData.sort = "asc";
          formData.asc = [this.sortByField];
        }


        httpServiceCustomer.customerService
          .getBeneficiariesByFile(formData, this.customer.company_id, this.accessToken)
          .then(function (response) {
            // handle success
            return response;
          })
          .then((response) => {
            if (response.status == 200) {
              if (this.perPage > 5000) {
                this.selectedBeneficiaries = response.data.results;
                this.perPage = 10;
              } else {
                this.customerBeneficiaries = response.data.results;
              }
              this.beneficiariesCount = response.headers["x-up-count"]; //["Content-Length"];
            } else if (response.status == 400 || response.status == 403) {
              this.customerBeneficiaries = null;
            }
            // this.showModalPopup("modal_popup_loading", false);
          })
          .catch(function () {
            // this.showModalPopup("modal_popup_loading", false);
            // handle error
          });
      },
      loadDeliveryAddresses() {
        // retreive customer delivery from service
        var formData = "?brand=" + this.filters.product.brand;
        formData += "&environment=card";
        formData += "&per_page=" + 1000 + "&page=" + 1;

        httpServiceCompany.userService
          .getAddressPoints(this.customer.company_id, formData, this.accessToken)
          .then(function (response) {
            // handle success
            return response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.deliveryAddresses = response.data.results;
              // if (this.deliveryAddresses.length === 1) {
              this.selectedDeliveryAddress = this.deliveryAddresses[0].codcom;
              this.deliveryAddresses.unshift({ codcom: 0 });
              this.filters.deliveryAddress = 0;
              // }
            } else if (response.status == 400 || response.status == 403) {
              this.deliveryAddresses = null;
            }
            // this.showModalPopup("modal_popup_loading", false);
          })
          .catch(() => {
            // handle error
            // this.showModalPopup("modal_popup_loading", false);
          });
      },
      isSelectedProduct(product) {
        return product === this.filters.product.brand;
      },
      isSelectedCardStatus(status) {
        return status === this.filters.cardStatus;
      },
      isSelectedProductType(status) {
        return status === this.filters.productType;
      },
      isSelectedFilterAddress(addressCode) {
        return addressCode === this.filters.deliveryAddress;
      },
      productSelected(event) {
        console.log(event);
        this.filters.product = utils.getProductByBrand(
          event.target.value,
          this.cardProducts
        );
        this.selectedBeneficiaries = [];
        this.isSelectedAllCustomerBeneficiaries = false;

        this.loadCustomerBeneficiaries();
      },
      cardStatusSelected(event) {
        this.filters.cardStatus = event.target.value;
        this.selectedBeneficiaries = [];
        this.isSelectedAllCustomerBeneficiaries = false;

        this.loadCustomerBeneficiaries();
      },
      productTypeSelected(event) {
        this.filters.productType = event.target.value;
        this.selectedBeneficiaries = [];
        this.isSelectedAllCustomerBeneficiaries = false;

        this.loadCustomerBeneficiaries();
      },
      addressFilterSelected(event) {
        this.filters.deliveryAddress = event.target.value;
        this.selectedBeneficiaries = [];
        this.isSelectedAllCustomerBeneficiaries = false;

        this.loadCustomerBeneficiaries();
      },
      addressActionSelected(event) {
        this.selectedDeliveryAddress = event.target.value;
      },
      actionSelected(event) {
        this.actionOrderErrors= null;
        this.selectedAction = event.target.value;
        switch (this.selectedAction) {
          case "REPL":
          case "VALIDATE_REPL":
          case "PIN":
          case "VALIDATE_PIN":
            document.getElementById("addressActionSelect").style.visibility =
              "visible";
            break;
            case "DELETE_BENEFICIARY" :
              this.showModalPopup("modal_popup_delete_ben_info", true);
              break;
          // case "ACT_ALL":
          //   document.getElementById("addressActionSelect").style.visibility =
          //     "hidden";
          //   this.getExcelBeneficiaries2().then(result => {
          //     this.selectedBeneficiaries = result;
          //   });
          //   break;
          default:
            document.getElementById("addressActionSelect").style.visibility =
              "hidden";
        }
      },
      getClassForCardStatus(status) {
        switch (status) {
          case "A":
            return "background-active";
          case "B":
          case "F":
          case "D":
            return "background-blocked";
          case "C":
          case "X":
            return "background-inactive";
          case "J":
          case "L":
            return "background-cancelled";
          case "E":
          case "I":
          case "M":
          case "N":
          case "O":
          case "P":
          case "R":
          case "S":
            return "background-processing";
          case "RN":
            return "background-will-expire";
          case "RC":
            return "background-blocked";
          case "RP":
            return "background-active";

          default:
            return "background-active";
        }
      },
      getProductNameMethod(productId) {
        return utils.getProductName(productId);
      },
      loadAndCheckAllBeneficiaries() {
        this.perPage = 10000;
        this.isSelectedAllCustomerBeneficiaries =
          !this.isSelectedAllCustomerBeneficiaries;
        if (this.isSelectedAllCustomerBeneficiaries) {
          this.filters.beneficiaryStatus = "A";
          this.loadCustomerBeneficiaries();
        } else {
          this.selectedBeneficiaries = [];
        }
      },
      async getExcelBeneficiaries() {
        // retreive customer beneficiaries from service
        var formData = "?product=" + this.filters.product.card;
        formData += "&brand=" + this.filters.product.brand;
        if (this.filters.beneficiaryStatus) {
          formData += "&beneficiary_status=" + this.filters.beneficiaryStatus;
        }
        if (this.filters.cardStatus) {
          formData += "&card_status=" + this.filters.cardStatus;
        }
        if (
          this.filters.deliveryAddress !== null &&
          this.filters.deliveryAddress > 0
        ) {
          formData += "&coddp=" + this.filters.deliveryAddress;
        }
        if (this.filters.keyword) {
          formData += "&keyword=" + this.filters.keyword;
        }
        formData += "&per_page=" + 100000 + "&page=" + 1;

        httpServiceCustomer.customerService
          .searchCards(formData, this.customer.company_id, this.accessToken)
          .then(function (response) {
            // handle success
            return response;
          })
          .catch(() => {
            // handle error
            // this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.excelBeneficiaries = response.data;
              this.$refs.download.$el.click();
              // return response.data;
            } else {
              return null;
            }
            // this.showModalPopup("modal_popup_loading", false);
          });
        // return null;
      },
      getExcelBeneficiaries2() {
        // retreive customer beneficiaries from service
        var formData = "?product=" + this.filters.product.card;
        formData += "&brand=" + this.filters.product.brand;
        if (this.filters.beneficiaryStatus) {
          formData += "&beneficiary_status=" + this.filters.beneficiaryStatus;
        }
        if (this.filters.cardStatus) {
          formData += "&card_status=" + this.filters.cardStatus;
        }
        if (
          this.filters.deliveryAddress !== null &&
          this.filters.deliveryAddress > 0
        ) {
          formData += "&coddp=" + this.filters.deliveryAddress;
        }
        if (this.filters.keyword) {
          formData += "&keyword=" + this.filters.keyword;
        }
        formData += "&per_page=" + 100000 + "&page=" + 1;
        this.showModalPopup("modal_popup_loading", true);
        return httpServiceCustomer.customerService
          .getCardsFile(formData, this.customer.company_id, this.accessToken)
          .then((response) => {
            if (response.status == 200) {
              var blob = new Blob(
                [utils.base64ToArrayBuffer(response.data.content)],
                {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
                }
              );
              saveAs(blob, response.data.name);
              this.showModalPopup("modal_popup_loading", false);
              // download content
            } else if (response.status == 400 || response.status == 403) {
              this.deliveryAddresses = null;
              this.error = { code: 500 };
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
            } else if (response.status == 404) {
              // show file not found
              this.error = { code: 500 };

              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
            } else {
              this.error = { code: 500 };

              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
            }
          })
          .catch(() => {
            this.error = { code: 500 };
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          });
        // return null;
      },
      isBeneficiaryChecked(entry) {
        for (let index in this.selectedBeneficiaries) {
          if (entry.id === this.selectedBeneficiaries[index].id) {
            return index;
          }
        }
        return -1;
      },
      beneficiaryChecked(element, entry) {
        if (element.checked) {
          for (let index in this.selectedBeneficiaries) {
            if (entry.id === this.selectedBeneficiaries[index].id) {
              return;
            }
          }
          this.selectedBeneficiaries.push(entry);
        } else {
          for (let index in this.selectedBeneficiaries) {
            if (entry.id === this.selectedBeneficiaries[index].id) {
              this.selectedBeneficiaries.splice(index, 1);
            }
          }
        }
      },
      removeBeneficiary(entry) {
        for (let index in this.selectedBeneficiaries) {
          if (entry.id === this.selectedBeneficiaries[index].id) {
            this.selectedBeneficiaries.splice(index, 1);
          }
        }
        if (this.selectedBeneficiaries.length === 0) {
          this.viewDetails(false);
        }
      },
      viewDetails(open) {
        this.openDetails = open;
      },
      submitAction() {
        this.showModalPopup("modal_popup_loading", true);
        this.actionSuccess = false;
        this.actionOrderErrors = null;
        this.error = null;
        let details = [];
        for (let index in this.selectedBeneficiaries) {
          details.push({
            card_id: this.selectedBeneficiaries[index].accounts[0].card.id,
            address:
              this.selectedDeliveryAddress === null
                ? (this.deliveryAddresses ? this.deliveryAddresses[0].codcom : 0)
                : this.selectedDeliveryAddress,
          });
        }
        let cardsActionData = {
          id: 0,
          type: this.selectedAction, //"PIN" reemitere PIN
          //"REPL" reemitere CARD
          customer_id: this.customer.company_id,
          product: this.filters.product.card,
          external_number: this.purchaseOrder,
          text_on_invoice: this.generalComment,
          details: details,
        };
        httpServiceCustomer.customerService
          .cardsAction(
            cardsActionData,
            this.accessToken,
            this.userRole === "FAC" ? this.user.username : null
          )
          .then((response) => {
            if (response.status === 200) {
              this.actionSuccess = true;
              this.error = null;
              this.selectedBeneficiaries = null;
              this.viewDetails(false);
              this.selectedBeneficiaries = [];
              this.loadCustomerBeneficiaries();
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
            }
          })
          .catch((error) => {
            // handle success
            if (error.response.data.code) {
              this.error = error.response.data;
              this.actionSuccess = false;
            } else if (error.response.status === 409) {
              // this.error = { code: "409" };
            } else {
              this.error = { code: "500" };
            }
            this.showModalPopup("modal_popup_loading", false);
            this.getResponseErrors(error.response);
            this.viewDetails(false);
          });
      },
      getResponseErrors(response) {
        this.actionOrderErrors = null;
        if (response.headers["link"]){
          let errorsLink = response.headers["link"].split(";")[0];
          errorsLink = errorsLink.replace(">", "");
          errorsLink = errorsLink.replace("<", "");
          if (errorsLink.includes("exceptions_type")) {
            httpServiceCustomer.customerService
              .getOrderErrors(errorsLink, this.accessToken)
              .then((response) => {
                if (response.status === 200) {
                  this.actionOrderErrors = response.data.errors;
                  this.error = { code: "ERROR" };
                }
                // this.showModalPopup("modal_popup_loading", false);
              })
              .catch((error) => {
                // handle success
                if (error.response.data) {
                  this.actionSuccess = false;
                  this.error = { code: error.response.data.code };
  
                  this.viewDetails(false);
                } else if (error.response.status === 409) {
                  // modal_popup_confirmPinRequest;
                  this.error = { code: "409" };
                } else {
                  this.error = { code: "500" };
                }
                // this.showModalPopup("modal_popup_loading", false);
              });
          }
        }
        this.showModalPopup("modal_popup_info", true);
      },
      validateSelection() {
        if (this.selectedAction === "CHOOSE") {
          this.error = { code: this.selectedAction };
          this.showModalPopup("modal_popup_info", true);
          return;
        }
        if (
          this.selectedAction === "REPL" ||
          this.selectedAction === "VALIDATE_REPL"
        ) {
          if (this.selectedDeliveryAddress === null) {
            this.error = { code: "NOADDRESS" };
            this.showModalPopup("modal_popup_info", true);
            return;
          }
        } else if (
          this.selectedAction === "PIN" ||
          this.selectedAction === "VALIDATE_PIN"
        ) {
          // if not PIN by IVR
          if (this.selectedDeliveryAddress === null) {
            this.error = { code: "NOADDRESS" };
            this.showModalPopup("modal_popup_info", true);
            return;
          }
        }
        this.viewDetails(true);
      },
      showModalPopup(elementId, show, entity = null) {
        if (show) {
          this.choosenAccount = entity;
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          this.choosenAccount = null;
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      checkAllBeneficiaries(element) {
        if (element.checked) {
          for (let index in this.customerBeneficiaries) {
            let selectedIndex = this.isBeneficiaryChecked(
              this.customerBeneficiaries[index]
            );
            if (selectedIndex < 0) {
              this.selectedBeneficiaries.push(this.customerBeneficiaries[index]);
            }
          }
        } else {
          for (let index in this.customerBeneficiaries) {
            let selectedIndex = this.isBeneficiaryChecked(
              this.customerBeneficiaries[index]
            );
            if (selectedIndex >= 0) {
              this.selectedBeneficiaries.splice(selectedIndex, 1);
            }
          }
        }
      },
      cardHasAction(state) {
        switch (state) {
          case "B":
          case "F":
          case "D":
          case "RC":
          case "RP":
            return true;
          default:
            return false;
        }
      },
      cardInfo(cardid) {
        for (let index in this.selectedBeneficiaries) {
          if (
            this.selectedBeneficiaries[index].accounts[0].card.id + "" ===
            cardid
          ) {
            return (
              this.selectedBeneficiaries[index].first_name +
              " " +
              this.selectedBeneficiaries[index].last_name
            );
          }
        }
        return null;
      },
    },
    computed: {
      cardProducts() {
        let cardProducts = [];
        if (this.customer) {
          for (let indexp in products) {
            for (let index in this.customer.products) {
              if (
                this.customer.products[index].card > 0 &&
                this.customer.products[index].card === products[indexp].card
              ) {
                cardProducts.push(products[indexp]);
              }
            }
          }
        }
        return cardProducts;
      },
      isFilterProductReward() {
        return this.filters.product.brand === "rewards";
      },
    },
    watch: {
      currentPage: function () {
        this.loadCustomerBeneficiaries();
      },
    },
    mounted() {
      this.accessToken = Cookies.get("token");
      let statusCard = utils.getUrlParam("status_card");
      if (statusCard) {
        this.filters.cardStatus = statusCard;
      }
      let productURL = utils.getUrlParam("product");
      if (productURL) {
        this.filters.product = utils.getProductById(
          parseInt(productURL),
          this.customer.products
        );
      } else {
        this.filters.product = this.cardProducts[0];
      }
      if (this.filters.product) {
        this.loadCustomerBeneficiaries();
        this.loadDeliveryAddresses();
      }
      this.selectedBeneficiaries = [];
    },
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
  .selectAll {
    background: #f49400 !important;
    color: #fff !important;
  }

  .selectAll.isActive {
    background: #fff !important;
    color: #585858 !important;
  }

  .loading-message {
    display: flex;
    align-items: flex-start;
  }

  .loading-message img {
    padding-left: 20px;
    padding-right: 20px;
    width: 25px;

  }
</style>
